import React, { useState } from 'react';

import { Button, Icon } from '@rbilabs/universal-components';

import LanguageSelectorModal from 'components/language-selector-modal';
import { useLocale } from 'state/intl';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';
import { formatActiveLanguageForRegion } from 'utils/language/format-active-language-for-region';

export interface OptionalColorProps {
  color?: string;
}

const LanguageSelector: React.FC<React.PropsWithChildren<OptionalColorProps>> = ({
  color = primitive.$mayoEggWhite,
}) => {
  const { language, region } = useLocale();
  const [showLanguageSelectorModal, setShowLanguageSelectorModal] = useState(false);

  const onModalDismiss = () => {
    setShowLanguageSelectorModal(false);
  };

  const onModalShow = () => {
    setShowLanguageSelectorModal(true);
  };

  return (
    <>
      <Button
        testID="language-selector-button"
        variant="ghost"
        justifyContent="flex-start"
        p="$0"
        onPress={onModalShow}
        color={color}
        leftIcon={<Icon variant="language" color={color} {...hiddenAccessibilityPlatformProps} />}
        accessibilityLabel={t('languageAndRegionSelector')}
      >
        {formatActiveLanguageForRegion(language, region)}
      </Button>
      {showLanguageSelectorModal && <LanguageSelectorModal onModalDismiss={onModalDismiss} />}
    </>
  );
};

export default LanguageSelector;
